enum StatusFracionamento {
    Separacao = 0,
    Nota = 1,
    Entrega = 2,
    Expedicao = 3,
    Separado = 4,
    Cancelado = 5
}

export default StatusFracionamento;